import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

export type PageNumber = {
  key: number;
  value: string;
};

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit, OnChanges {
  @Output() currentPageDetail = new EventEmitter<any>();
  @Input() listLength!: number;
  @Input() resetInd!: boolean;
  @Input() disableInit = false;
  @Input() hideLimit = 10;
  @Input() pageSizeList = [10, 15, 20, 25];
  @Input () isRuleListing!: boolean;
  @Input() set pageNo(value: number) {
    if (value !== this.ClickedButtonNumber) {
      this.ClickedButtonNumber = value;
      this.generatePageList(
        this.ClickedButtonNumber,
        this.paginationButtonCount
      );
      this.itemStartEndListing();
    }
  }
  isPaginationVisble: boolean = true;
  itemsPerPage = 10;
  itemsPerPageList: number[] = [];
  paginationButtonCount!: number;
  listStartsFrom = 1;
  listEndsFrom = 10;
  pageList: PageNumber[] = [];
  ClickedButtonNumber = 1;

  ngOnInit(): void {
    this.isPaginationVisble = this.listLength > this.hideLimit;
    this.setItemsPerPageList();
    // this.buttonCountFn(this.listLength, this.itemsPerPage);
    if (!this.disableInit) {
      this.currentPageDetail.emit({
        button_no: this.ClickedButtonNumber,
        item_per_page: this.itemsPerPage,
      });
    }
    if(this.isRuleListing){
      this.itemsPerPage = 25;
    }else{
      this.itemsPerPage = 10;
    }
    // this.currentPageDetail.emit({button_no : this.ClickedButtonNumber, item_per_page : this.itemsPerPage});
    if (this.listLength == 0) {
      this.isPaginationVisble = false;
    }
  }
  selectListPerPage(event: any) {
    if (event.target.value) {
      this.itemsPerPage = +event.target.value;
    }
    this.ClickedButtonNumber = 1;
    this.buttonCountFn(this.listLength, this.itemsPerPage);
    this.currentPageDetail.emit({
      button_no: this.ClickedButtonNumber,
      item_per_page: this.itemsPerPage,
    });
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listLength']?.currentValue!== undefined) {
      this.isPaginationVisble = this.listLength > this.hideLimit;
      this.buttonCountFn(this.listLength, this.itemsPerPage);
      this.setItemsPerPageList();
    }
  }

  setItemsPerPageList() {
    const index = this.pageSizeList.findIndex(
      (pageSize) => this.listLength < pageSize
    );
    if (index !== -1) {
      this.itemsPerPageList = this.pageSizeList.slice(0, index + 1);
    } else {
      this.itemsPerPageList = JSON.parse(JSON.stringify(this.pageSizeList));
    }
    this.itemsPerPage = this.itemsPerPageList[0];
    this.buttonCountFn(this.listLength, this.itemsPerPage);
  }

  buttonCountFn(itemListLength: number, itemPerPage: number) {
    this.paginationButtonCount = Math.ceil(itemListLength / itemPerPage);
    this.generatePageList(this.ClickedButtonNumber, this.paginationButtonCount);
    this.itemStartEndListing();
  }

  onPageButtonClicked(num: any) {
    this.ClickedButtonNumber = num;
    this.generatePageList(this.ClickedButtonNumber, this.paginationButtonCount);
    this.itemStartEndListing();
    this.currentPageDetail.emit({
      button_no: this.ClickedButtonNumber,
      item_per_page: this.itemsPerPage,
    });
  }

  itemStartEndListing() {
    this.listStartsFrom =
      (this.ClickedButtonNumber - 1) * this.itemsPerPage + 1;
    this.listEndsFrom =
      this.ClickedButtonNumber * this.itemsPerPage < this.listLength
        ? this.ClickedButtonNumber * this.itemsPerPage
        : this.listLength;
  }
  nextButton() {
    if (this.ClickedButtonNumber < this.paginationButtonCount) {
      this.ClickedButtonNumber += 1;
      this.generatePageList(
        this.ClickedButtonNumber,
        this.paginationButtonCount
      );
      this.itemStartEndListing();
      this.currentPageDetail.emit({
        button_no: this.ClickedButtonNumber,
        item_per_page: this.itemsPerPage,
      });
    }
  }
  previousButton() {
    if (this.ClickedButtonNumber !== 1) {
      this.ClickedButtonNumber -= 1;
      this.generatePageList(
        this.ClickedButtonNumber,
        this.paginationButtonCount
      );
      this.itemStartEndListing();
      this.currentPageDetail.emit({
        button_no: this.ClickedButtonNumber,
        item_per_page: this.itemsPerPage,
      });
    }
  }

  generatePageList(currentPage: number, maxPage: number) {
    let listItems: PageNumber[] = [];
    listItems.push({
      key: 1,
      value: '1',
    });

    let previousPage = currentPage - 1;
    if (maxPage < 8) {
      listItems = [...listItems, ...this.getPageNumbers(2, maxPage)];
    } else {
      if (currentPage <= 4) {
        listItems = [...listItems, ...this.getPageNumbers(2, 4)];
      } else if (currentPage <= maxPage - 4) {
          listItems.push({
            key: previousPage - 1,
            value: '...',
          });
          listItems.push({
            key: previousPage,
            value: previousPage.toString(),
          });
          listItems.push({
            key: currentPage,
            value: currentPage.toString(),
          });
        }

      if (currentPage > maxPage - 4) {
        listItems.push({
          key: maxPage - 5,
          value: '...',
        });
        listItems = [
          ...listItems,
          ...this.getPageNumbers(maxPage - 4, maxPage),
        ];
      } 
      else if(maxPage) {
        let nextPage = listItems[listItems.length - 1].key + 1;
        listItems.push({
          key: nextPage,
          value: nextPage.toString(),
        });
        listItems.push({
          key: nextPage + 1,
          value: '...',
        });
        listItems.push({
          key: maxPage,
          value: maxPage.toString(),
        });
      }
    }
    this.pageList = listItems;
  }
  // generatePageList(currentPage: number, maxPage: number) {
  //   let listItems: PageNumber[] = [];
  //   listItems.push({
  //     key: 1,
  //     value: '1',
  //   });
  
  //   let previousPage = currentPage - 1;
  //   let nextPage = currentPage + 1;
  
  //   if (maxPage <= 7) {
  //     listItems = [...listItems, ...this.getPageNumbers(2, maxPage)];
  //   } else {
  //     if (currentPage <= 4) {
  //       listItems = [...listItems, ...this.getPageNumbers(2, 4)];
  //       listItems.push({
  //         key: 0,
  //         value: '...',
  //       });
  //       listItems.push({
  //         key: maxPage,
  //         value: maxPage.toString(),
  //       });
  //     } else if (currentPage >= maxPage - 3) {
  //       listItems.push({
  //         key: 2,
  //         value: '...',
  //       });
  //       listItems = [
  //         ...listItems,
  //         ...this.getPageNumbers(maxPage - 3, maxPage),
  //       ];
  //     } else {
  //       listItems.push({
  //         key: 2,
  //         value: '...',
  //       });
  //       listItems.push({
  //         key: previousPage,
  //         value: previousPage.toString(),
  //       });
  //       listItems.push({
  //         key: currentPage,
  //         value: currentPage.toString(),
  //       });
  //       listItems.push({
  //         key: nextPage,
  //         value: nextPage.toString(),
  //       });
  //       listItems.push({
  //         key: 0,
  //         value: '...',
  //       });
  //       listItems.push({
  //         key: maxPage,
  //         value: maxPage.toString(),
  //       });
  //     }
  //   }
  //   this.pageList = listItems;
  // }
  

  getPageNumbers(from: number, to: number) {
    const listItems: PageNumber[] = [];
    while (from <= to) {
      listItems.push({
        key: from,
        value: from.toString(),
      });
      from++;
    }
    return listItems;
  }
}
